
import {defineComponent, PropType} from "vue";
import {PageElementMetadataRestDtoModel} from "@/models/PageElementMetadataRestDtoModel";
import {WysiwygCustomDesignTemplateRestDtoModel} from "@/models/WysiwygCustomDesignTemplateRestDtoModel";
import {AuthContext} from "@/context/AuthContext";

export default defineComponent({
  name: "MetadataIcons",
  props: {
    customDesignTemplate: Object as PropType<WysiwygCustomDesignTemplateRestDtoModel>,
    pageElementMetadata: Object as PropType<PageElementMetadataRestDtoModel>,
    iconClass: {
      type: String,
      required: false,
      default: 'page-element-metadata-warning'
    },
    hasEyebrow: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false
    },
    hasBoxShadow: {
      type: Boolean,
      default: false
    },
    hasOverlays: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    lockedText(): string | null {
      if (this.isLocked) {
        let textArray = [] as string[];

        if (this?.pageElementMetadata?.is_copy_locked) {
          textArray.push('Copy locked');
        }
        if (this?.pageElementMetadata?.is_delete_locked) {
          textArray.push('Delete locked');
        }
        if (this?.pageElementMetadata?.is_write_locked) {
          textArray.push('Write locked');
        }

        let returnText = '' as string;
        for (let i = 0; i < textArray.length; i++) {
          returnText += textArray[i];

          if (i + 1 !== textArray.length) {
            returnText += '<br>';
          }
        }

        return returnText;
      }

      return null;
    },
    isDpUser(): boolean {
      return AuthContext.isDpUser();
    },
    isLocked(): boolean {
      return (this.pageElementMetadata?.is_copy_locked
        || this.pageElementMetadata?.is_delete_locked
        || this.pageElementMetadata?.is_write_locked) ?? false;
    }
  }
})
